"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productOptionsSelector = exports.baseCurrencySelector = exports.baseCurrencyPriceSelector = void 0;
var _reselect = require("reselect");
var _config = _interopRequireDefault(require("../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var productOptionsSelector = exports.productOptionsSelector = (0, _reselect.createSelector)([function (state) {
  return state.apexCore.product.products;
}], function (products) {
  var isMisconfigured = false;
  var productsOptions = (_config["default"].BaseCurrencies || []).map(function (currency) {
    var product = products.find(function (p) {
      return p.Product === currency;
    });
    isMisconfigured = isMisconfigured || !product;
    return isMisconfigured ? null : {
      value: currency,
      label: product.ProductFullName
    };
  });
  return {
    productsOptions: productsOptions,
    isMisconfigured: isMisconfigured
  };
});
var instrumentHasProductId = function instrumentHasProductId(prodId) {
  return function (ins) {
    return ins.Product1 === prodId || ins.Product2 === prodId;
  };
};
var getInstrumentsById = function getInstrumentsById(instruments, id) {
  return instruments.filter(instrumentHasProductId(id));
};
var findInstrumentsById = function findInstrumentsById(instruments, id) {
  return instruments.find(instrumentHasProductId(id));
};
var findInstrumentLevel = function findInstrumentLevel(instruments, level1, id) {
  var instrument = findInstrumentsById(instruments, id);
  if (instrument) {
    var level = level1[instrument.InstrumentId];
    return level && {
      instrument: instrument,
      level: level
    };
  }
};
var getValueById = function getValueById(inst, level, id) {
  return inst.Product1 === id ? level.LastTradedPx : 1 / level.LastTradedPx;
};
var baseCurrencyPriceSelector = exports.baseCurrencyPriceSelector = (0, _reselect.createSelector)([function (state) {
  return state.apexCore.level1;
}, function (state) {
  return state.apexCore.instrument.instruments;
}, function (state) {
  return state.apexCore.product.products;
}, function (state) {
  return state.user.userConfig;
}, function (state, productId) {
  return productId;
}], function (level1, instruments, products, userConfig, productId) {
  var baseCurrency = userConfig.find(function (config) {
    return config.Key === 'BaseCurrency';
  });
  if (!baseCurrency || !baseCurrency.Value) return;
  baseCurrency = baseCurrency.Value;

  // Case:
  // * BaseCurrency is the same as the productId
  var product = products.find(function (p) {
    return p.ProductId === productId;
  });
  var baseProduct = products.find(function (p) {
    return p.Product === baseCurrency;
  });
  if (product === baseProduct) return;
  var baseProductId = baseProduct && baseProduct.ProductId;
  var productInstruments = getInstrumentsById(instruments, productId);

  // Case:
  // * BaseCurrency is on level 1 on the same instrument as the productId
  var sharedInstrument = findInstrumentsById(productInstruments, baseProductId);
  if (sharedInstrument) {
    var level = level1[sharedInstrument.InstrumentId];
    if (!level) return;
    var _value = getValueById(sharedInstrument, level, productId);
    return _objectSpread(_objectSpread({}, baseProduct), {}, {
      value: _value
    });
  }

  /* Case:
  ** BaseCurrency is on level1 but on another instrument **
  For this we need two instruments these should have a product that is paired with the current
  product and the baseCurrency but also these instruments need to exist on level1
   */
  var baseCurrencyInstruments = getInstrumentsById(instruments, baseProductId);
  var result;
  products.forEach(function (_ref) {
    var ProductId = _ref.ProductId;
    if (result) return;
    var baseObj = findInstrumentLevel(baseCurrencyInstruments, level1, ProductId);
    var prodOb = findInstrumentLevel(productInstruments, level1, ProductId);
    if (baseObj && prodOb) {
      result = {
        id: ProductId,
        base: baseObj,
        product: prodOb
      };
    }
  });
  // This means there's no level available for either of product or baseCurrency
  if (!result) return;
  var proxyProductValue = getValueById(result.product.instrument, result.product.level, result.id);
  var proxyBaseCurrencyValue = getValueById(result.base.instrument, result.base.level, result.id);
  var value = proxyBaseCurrencyValue / proxyProductValue;
  return _objectSpread(_objectSpread({}, baseProduct), {}, {
    value: value
  });
});
var baseCurrencySelector = exports.baseCurrencySelector = (0, _reselect.createSelector)(function (state) {
  return state.user.userConfig;
}, function (userConfig) {
  return (userConfig.find(function (config) {
    return config.Key === 'BaseCurrency';
  }) || {}).Value || 'USD';
});